<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Transfer Saldo</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <div class="section full mt-2">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item pt-2 pb-2 pl-3 pr-3">
                            <div class="in">
                                <div>Saldo saat ini</div>
                                <span
                                    class="text-primary"
                                    style="font-weight: bold;"
                                    >Rp {{ customer.balance | rupiah }}</span
                                >
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="section inset mt-3">
                <div class="form-group boxed p-0 mb-3">
                    <div class="input-wrapper">
                        <label class="label">Nomor Ponsel Penerima</label>
                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-model="data.phone"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        />
                        <i class="clear-input">
                            <ion-icon name="close-circle"></ion-icon>
                        </i>
                    </div>

                    <div class="mt-1">
                        <div
                            class="chip chip-media"
                            style="font-size:11px;background:#efefef;"
                            @click="openPhoneBook()"
                        >
                            <i class="chip-icon bg-primary">
                                <ion-icon name="journal-outline"></ion-icon>
                            </i>
                            <span class="chip-label">Kontak</span>
                        </div>
                    </div>
                </div>

                <div class="form-group input-nominal p-2">
                    <label class="label" style="font-weight: bold;"
                        >Nominal Transfer</label
                    >
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">Rp</span>
                        </div>
                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-model="data.nominal"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                            @input="inputNominal()"
                        />
                    </div>
                </div>

                <div
                    class="form-group basic mt-1 pb-0"
                    style="white-space: nowrap; overflow: auto;"
                >
                    <button
                        v-for="item in nominal"
                        :key="item"
                        class="btn btn-outline-primary btn-sm mr-1 mb-1"
                        style="border-radius:50px;border:1px solid;"
                        @click="inputNominal(item)"
                    >
                        <ion-icon name="add-circle"></ion-icon> Rp
                        {{ item | rupiah }}
                    </button>
                </div>

                <div
                    class="alert alert-info-custom mt-1 mb-1 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <h5>Keterangan</h5>
                            <ul style="color:#17273e;" class="mb-0">
                                <li>Transfer saldo minomal Rp 10.000</li>
                                <li>
                                    Pastikan nomor handphone penerima sudah
                                    benar. Jika terdapat kendala harap
                                    menghubungi Customer Service
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="form-group basic">
                    <div class="form-group basic">
                        <ButtonLoader
                            :loading="loading.check"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            @click.native="check_receiver()"
                            >Periksa</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </div>

        <action-sheet
            ref="confirm"
            :title="'Konfirmasi Transfer'"
            :inset="false"
        >
            <div class="mb-2">
                <small>Kamu akan melakukan transfer saldo ke</small>
                <h2 class="text-uppercase mb-0">{{ data.name }}</h2>
                <span>{{ data.phone }}</span>
            </div>
            <div>
                <small>Nominal Transfer</small>
                <h1>
                    <small style="font-size:15px;">Rp</small>
                    {{ data.nominal | rupiah }}
                </h1>
            </div>
            <div class="form-group basic">
                <ButtonLoader
                    :loading="loading.button"
                    :styled="'btn btn-primary btn-block btn-lg'"
                    @click.native="verifyWiithoutPin()"
                    v-if="customer.pin_trx == 'DISABLED'"
                    >Transfer</ButtonLoader
                >
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="verifyWithPin()"
                    v-else
                >
                    Transfer
                </button>
            </div>
        </action-sheet>

        <action-sheet ref="status" :title="'Transfer Saldo'" :inset="false">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Berhasil diproses</h3>
                <p>Transfer saldo Anda berhasil diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Transaksi
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="action_sheet_status('hide')"
                >
                    Tutup
                </button>
            </div>
        </action-sheet>

        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        props: ['toast_reference'],
        data() {
            return {
                loadingContent: false,
                loading: {
                    button: false,
                    check: false,
                },
                nominal: [10000, 50000, 100000, 500000, 1000000, 2000000],
                data: {
                    phone: '',
                    name: '',
                    nominal: '',
                },
            };
        },
        created() {
            this.loadingContent = true;
            setTimeout(() => (this.loadingContent = false), 500);
        },
        computed: {
            ...mapState(['toast', 'customer']),
        },
        methods: {
            ...mapActions(['getCustomer']),
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            directToHistory() {
                this.action_sheet_status('hide');
                this.$router.push({
                    name: 'transaction.index',
                });
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            inputNominal(nominal) {
                this.$store.commit('RESET_TOAST');
                if (this.data.nominal == '') {
                    this.data.nominal = '0';
                }
                if (nominal == undefined) {
                    const nominal_request = parseInt(this.data.nominal);
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                } else {
                    const nominal_request =
                        parseInt(this.data.nominal.replace(/[^,\d]/g, '')) +
                        nominal;
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                }
            },
            clear_data() {
                this.$store.commit('RESET_TOAST');
                this.data = {
                    phone: '',
                    name: '',
                    nominal: '',
                };
            },
            check_receiver() {
                this.$store.commit('RESET_TOAST');
                this.data.nominal = this.data.nominal.replace(/[^,\d]/g, '');
                this.loading.check = true;
                $axios
                    .post('/transfer/check', this.data)
                    .then(response => {
                        this.data.name = response.data.data.name;
                        this.loading.check = false;
                        this.action_sheet_confirm('show');
                    })
                    .catch(e => {
                        this.loading.check = false;
                        this.action_sheet_confirm('hide');
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                    });
            },
            action_sheet_confirm(value) {
                let element = this.$refs.confirm.$el;
                window.$(element).modal(value);
            },
            action_sheet_status(value) {
                let element = this.$refs.status.$el;
                window.$(element).modal(value);
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
            verifyWiithoutPin() {
                this.loading.button = true;
                $axios
                    .post('/transfer', this.data)
                    .then(() => {
                        this.getCustomer();
                        this.loading.button = false;
                        this.clear_data();
                        this.action_sheet_confirm('hide');
                        this.action_sheet_status('show');
                    })
                    .catch(e => {
                        this.loading.button = false;
                        this.action_sheet_confirm('hide');
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                    });
            },
            verifyWithPin() {
                this.action_sheet_confirm('hide');
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.data,
                        url_reference: '/transfer',
                        previous_page_reference: 'transfer',
                        next_page_reference: 'transfer',
                    },
                });
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.clear_data();
                        this.action_sheet_status('show');
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
        filters: {
            inputRupiah: function(value) {
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
